import FilterListIcon from "@mui/icons-material/FilterListRounded";
import SearchIcon from "@mui/icons-material/SearchRounded";
import { Badge, Box, Button, IconButton, Stack, Typography } from "@mui/material";
import { useState } from "react";
import RecordCounter from "@entrilia/shared/components/filters/RecordCounter";
import SearchField from "@entrilia/shared/components/inputs/SearchField";

interface Props {
  onSearch: (value: string) => void;
  onOpenFilters: () => void;
  rowCount: number;
  loading?: boolean;
  isAnyFilterApplied?: boolean;
  filterText?: string;
}

const WidgetListToolbar = ({ onSearch, onOpenFilters, rowCount, loading, isAnyFilterApplied, filterText }: Props) => {
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const handleCancelSearch = () => {
    setIsSearchOpen(false);
    onSearch("");
  };

  if (isSearchOpen) {
    return (
      <Stack direction="row" spacing={2} sx={{ width: "100%", alignItems: "center", px: 2, py: 1.25 }}>
        <SearchField onSearch={onSearch} fullWidth autoFocus debounceTimeMs={300} />
        <Button variant="text" color="secondary" onClick={handleCancelSearch}>
          Cancel
        </Button>
      </Stack>
    );
  }

  return (
    <Box
      sx={{
        width: "100%",
        minWidth: 0,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        px: 2,
        py: 1.75,
      }}
    >
      <Stack direction="row" spacing={1} sx={{ alignItems: "center", flex: "1 0 auto" }}>
        <RecordCounter records={rowCount} />
        {filterText && (
          <Stack direction="row" spacing={0.5} sx={{ alignItems: "center", minWidth: 0, flex: 1 }}>
            <Typography color="textSecondary">Filtered:</Typography>
            <Typography noWrap sx={{ flex: 1, width: 0, minWidth: 0 }}>
              {filterText}
            </Typography>
          </Stack>
        )}
      </Stack>
      <Stack direction="row" spacing={1} sx={{ alignItems: "center", flex: "0 1 auto" }}>
        <IconButton aria-label="search" disabled={loading} onClick={() => setIsSearchOpen(true)}>
          <SearchIcon />
        </IconButton>
        <IconButton aria-label="filter" disabled={loading} onClick={onOpenFilters}>
          <Badge variant="dot" color="primary" invisible={!isAnyFilterApplied}>
            <FilterListIcon />
          </Badge>
        </IconButton>
      </Stack>
    </Box>
  );
};

export default WidgetListToolbar;
